import { POST_ART_REQUEST, POST_ART_SUCCESS, POST_ART_FAIL, GET_ART_BY_USER_ID_SUCCESS, GET_ART_BY_USER_ID_REQUEST, GET_ART_BY_USER_ID_FAIL } from "./actionTypes"

const INIT_STATE = {
    error: "",
    loading: false,
    Arts: [],
    ArtsByUserId:[]
};

const Art = (state = INIT_STATE, action) => {
    switch (action.type) {
        /* Get Collection Name Verify */
        case POST_ART_REQUEST:
        case GET_ART_BY_USER_ID_REQUEST:
              return {
                ...state,
                error: "",
                loading: true,
              };
        
            case POST_ART_FAIL:
            case GET_ART_BY_USER_ID_FAIL:
              return {
                ...state,
                error: action.payload,
                loading: false,
              };
        
            case POST_ART_SUCCESS:
              return {
                ...state,
                error: "",
                loading: false,
              };
              case GET_ART_BY_USER_ID_SUCCESS:
                return {
                  ...state,
                  ArtsByUserId: action.payload.data || [],
                  loading: false,
                  error: "",
                };
        default:
            return state;
    }
}

export default Art